import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ParkStat } from '../models/park-stats';

// TODO call WS everywhere
@Injectable()
export class ParkUsageService {

  PARK_USE_API_URL : string = environment.serverUrl + "api/1/park/use";

  constructor(private httpClient : HttpClient) { }

  getTodayStat() : Observable<ParkStat> {
    return this.httpClient.get<ParkStat>(this.PARK_USE_API_URL + "/today");
  }

  getCurrentWeekStat() :  Observable<ParkStat> {
    return this.httpClient.get<ParkStat>(this.PARK_USE_API_URL + "/this-week");
  }

  getCurrentMonthStat() : Observable<ParkStat> {
    return this.httpClient.get<ParkStat>(this.PARK_USE_API_URL + "/this-month");
  }

  getYesterdayStat() :  Observable<ParkStat> {
    return this.httpClient.get<ParkStat>(this.PARK_USE_API_URL + "/yesterday");
  }

  getLastWeekStat() : Observable<ParkStat>{
    return this.httpClient.get<ParkStat>(this.PARK_USE_API_URL + "/last-week");
  }

  getLastMonthStat() :  Observable<ParkStat> {
    return this.httpClient.get<ParkStat>(this.PARK_USE_API_URL + "/last-month");
  }

}



// WEBPACK FOOTER //
// ./src/app/statistics/park-usage.service.ts